import { ReactElement, useEffect, useState } from "react";
import { Breadcrumb, Button, Layout, Row, Col, notification, Skeleton, message } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import firebase from "firebase/app";
import { BreadCrumbWrapper } from "../../components/GlobalStyles";
import { PREPARE_BOOKING_BRANCH, PREPARE_BOOKING_COURTS, SET_LOADING_STATE, RESET_LOADING_STATE } from "../../redux/constants";
import { BranchCard } from "./BranchCard";
import { getAuthState } from "../../redux/selectors";
import api from "../../redux/api/axiosInstance";

const { Content } = Layout;

export function Branches(): ReactElement {
  const history = useHistory();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [club, setClub] = useState<any>();
  const [branches, setBranches] = useState<any[]>([]);
  const { currentUser } = useSelector(getAuthState);
  const [loading, setLoading] = useState<boolean>(false);
  const { clubId } = useParams<{ clubId: string }>();

  useEffect(() => {
    async function getBranches() {
      dispatch({ type: SET_LOADING_STATE });
      api.post("getBranches", { clubId })
        .then((res) => {
          const { allBranchesWithClubsAndCourtsCount, clubData } = res.data;
          setClub(clubData);
          setBranches(allBranchesWithClubsAndCourtsCount);
          dispatch({ type: RESET_LOADING_STATE })
        })
        .catch((e) => {
          console.log(e);
          setBranches([]);
          setClub(undefined);
          dispatch({
            type: RESET_LOADING_STATE
          })
        })
    }
    getBranches();
  }, []);

  const onBook = async (record: any, clubData: any) => {
    dispatch({
      type: PREPARE_BOOKING_BRANCH,
      payload: { branch: { ...record, clubData } },
    });
    const courtSnapshots = await firebase
      .firestore()
      .collection("courts")
      .where("branchId", "==", record.firestoreRef)
      .get();
    if (courtSnapshots.size) {
      const courts = courtSnapshots.docs.map((doc) => doc.data());
      dispatch({
        type: PREPARE_BOOKING_COURTS,
        payload: { courts },
      });
      history.push(`/booking/${record.firestoreRef}/calendar`);
    } else {
      alert("There is no courts to book.");
    }
  };

  const requestAccess = () => {
    const email = currentUser?.email;
    const emailData = {
      from: email,
      to: club.contactEmail,
      subject: club.name,
      content: "This is request access email content"
    };
    api.post("sendEmail", emailData)
      .then(() => {
        const args = {
          message: t("club.request_access"),
          description:
            `You have successfully requested to ${club.name}`,
          duration: 3,
        };
        notification.success(args);
      }).catch(() => {
        const args = {
          message: t("error.oop"),
          description: t("error.request_error"),
          duration: 3,
        };
        notification.error(args);
      });
  }

  const notifyMe = () => {
    firebase
      .firestore()
      .collection("clubs")
      .doc(clubId)
      .update({ notify: firebase.firestore.FieldValue.arrayUnion({ id: currentUser?.id, email: true, phone: true }) })
      .then(() => {
        message.success("Thank you! We will notify you soon!");
      })
      .catch(e => {
        message.error("Oop! Something went wrong!");
      });
  }

  return (
    <Content>
      <Skeleton loading={loading}>
        <BreadCrumbWrapper>
          <Breadcrumb style={{ fontSize: 18 }}>
            <Breadcrumb.Item>{club?.name}</Breadcrumb.Item>
            <Breadcrumb.Item>{t("club.branches")}</Breadcrumb.Item>
          </Breadcrumb>
        </BreadCrumbWrapper>
      </Skeleton>

      <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
        {club && branches.map((b) => (
          <BranchCard branch={b} onBook={onBook} key={b.branchId} club={club} onRequestAccess={requestAccess} onNotify={notifyMe} />
        ))}
      </Row>
    </Content>
  );
}
